var InteractiveParametersGroup = require('./module/InteractiveParametersGroup');

/**
 * Обработчик интерактивных параметров на странице товара
 * @type {Object}
 */
var ProductPageInteractiveParametersManager = {
    /**
     * Используемые селекторы
     * @type {Object.<string, string|Object.<string, string>>}
     */
    selectors: {
        addToCartA: '.product-card a.add-to-cart',
        productIdInputAtQuickOrder: '#quick-order-product-id',
        prices: '.product-card .price, .product-card .prices__price',
        currentColor: '.product-card .colors .color.active',
        images: {
            header: '.big-header-wrapper img.product-image',
            card: '.product-card img.wp-post-image',
            quickOrder: '#quickorder img'
        }
    },
    /**
     * Изображение, обрабатываемое в данном обработчике, с указанием размера
     * @typedef {Object} ManagerImage
     * @property {jQuery|null} - jQuery-элемент изображения
     * @property {string} - Размер изображения: 'small' - небольшое, 'standard' - стандартное, 'big' - большое
     */
    /**
     * Изображения товара, соответствующие селекторам в this.selectors.images
     * @type {{
     *     header: ManagerImage,
     *     card: ManagerImage,
     *     big: ManagerImages
     * }}
     */
    images: {
        header: {
            $img: null,
            size: 'small'
        },
        card: {
            $img: null,
            size: 'standard'
        },
        quickOrder: {
            $img: null,
            size: 'small'
        },
        big: {
            $img: null,
            size: 'big'
        }
    },
    /**
     * Изначальный чистый хеш
     * @type {string}
     */
    initialCleanHash: '',
    /**
     * С "drawinglogo" ли в хеше страница
     * @type {boolean}
     */
    pageWithDrawinglogoHash: false,
    /**
     * Метод инициализирует обработчик
     */
    init: function () {
        var $img;
        for (var imageItem in this.images) {
            if (this.selectors.images[imageItem]) {
                if (($img = $(this.selectors.images[imageItem])).length) {
                    this.images[imageItem].$img = $img;
                }
            }
        }
        this.initialCleanHash = this.getCleanHash();
        this.pageWithDrawinglogoHash = (this.initialCleanHash === 'drawinglogo');
    },
    /**
     * Метод обновляет стоимость
     * @param {number|string} price
     */
    updatePrice: function (price) {
        $(this.selectors.prices).text(this.formatPrice(price));
    },
    /**
     * Метод форматирует стоимость
     * @param {number|string} price
     * @returns {string}
     */
    formatPrice: function (price) {
        return Math.ceil(price).toString() + ' руб.';
    },
    /**
     * Метод обновляет product_id
     * @param {number|string} productId
     */
    updateProductId: function (productId) {
        var $addToCartA = $(this.selectors.addToCartA),
            $productIdInputAtQuickOrder = $(this.selectors.productIdInputAtQuickOrder);
        // Кнопка "Купить"
        $addToCartA
            .attr('href', $addToCartA.attr('href').replace(/product_id=\d+/, 'product_id=' + productId))
                .data('product_id', productId)
                    .attr('data-product_id', productId);
        // Быстрый заказ
        $productIdInputAtQuickOrder.val(productId);
        // Изображение товара в карточке (для "отлетания" в корзину)
        this.images.card.$img.attr('id', 'image' + productId);
    },
    /**
     * Метод обновляет изображения товара
     * @param {Object} srcs - Адреса изображений
     * @param {string} srcs.small - Адрес небольшого изображения
     * @param {string} srcs.standard - Адрес станадартного изображения
     * @param {string} srcs.big - Адрес большого изображения
     */
    updateImage: function (srcs) {
        for (var imageItem in this.images) {
            if (srcs[this.images[imageItem].size]
                    && (this.images[imageItem].$img && (this.images[imageItem].$img.attr('src') !== srcs[this.images[imageItem].size]))) {
                this.images[imageItem].$img.attr('src', srcs[this.images[imageItem].size]);
            }
        }
    },
    /**
     * Метод возвращает очищенный от решетки хеш
     * @returns {string|undefined}
     */
    getCleanHash: function () {
        return document.location.hash !== '' ? document.location.hash.replace(/^#([^?]*).*/, '$1') : undefined;
    }
};
// Инициализация обработчка
ProductPageInteractiveParametersManager.init();

/**
 * Параметры интерактивных параметров
 * @type {Object.<string, InteractiveParameterConstructorParams>}
 */
var InteractiveParametersParams = {
    // Цвет
    colors: {
        selector: '.colors .color',
        indexBy: "data('parameter_color_translit')",
        classActive: 'active',
        classHidden: 'hidden',
        disabledCursor: 'default',
        /**
         * @this InteractiveParameter
         */
        init: function () {
            if (this.elementsCount) {
                var firstColorIndex, // Первый ненулевой цвет
                    initialColorIndex; // Цвет для изначального выбора
                $.each(this.elements, function (colorIndex) {
                    var colorHasPrice = false;
                    // Скрываю цвет без стоимости
                    $.each(this.data['capacity_to_price'], function (capacity, price) {
                        if (price > 0) {
                            if (!firstColorIndex) {
                                firstColorIndex = colorIndex;
                            }
                            return colorHasPrice = true;
                        }
                    });
                    if (!colorHasPrice) {
                        this.applyToSelfAndRelated('getHidden');
                    }
                });
                // Выбираю изначальный цвет
                initialColorIndex =
                    (!ProductPageInteractiveParametersManager.pageWithDrawinglogoHash
                        && this.isHidden(ProductPageInteractiveParametersManager.initialCleanHash) === false)
                            ? ProductPageInteractiveParametersManager.initialCleanHash // Цвет, переданный в хеше
                                : firstColorIndex;
                this.elements[initialColorIndex].getClicked();
            }
        },
        /**
         * @this InteractiveParameterElement
         */
        onClick: function () {
            if (this.InteractiveParameter.active) {
                this.InteractiveParameter.active.applyToSelfAndRelated('getUnclicked');
                this.InteractiveParameter.active.applyToSelfAndRelated('getEnabled');
            }
            this.InteractiveParameter.applyToSelfAndRelated('makeOnlyActive', [this.index]);
            this.applyToSelfAndRelated('getDisabled');
            this.applyToRelated('getClicked', [true]);
            ProductPageInteractiveParametersManager.updateImage({
                small: this.data['image_src_small'],
                standard: this.data['image_src'],
            });
            if (this.data['capacity_to_price'] && this.InteractiveParameter.InteractiveParametersGroup.isParameterDefinedAndHasElements('capacities')) {
                for (var capacityIndex in this.InteractiveParameter.InteractiveParametersGroup.InteractiveParameters.capacities.elements) {
                    if (this.data['capacity_to_price'][capacityIndex] > 0) {
                        if (this.InteractiveParameter.InteractiveParametersGroup.InteractiveParameters.capacities.elements[capacityIndex].hidden) {
                            this.InteractiveParameter.InteractiveParametersGroup.InteractiveParameters.capacities.elements[capacityIndex].applyToSelfAndRelated('getShown');
                        }
                        // Обнуляю нажатие на емкость, чтобы отрабатывало нажатие на емкость
                        this.InteractiveParameter.InteractiveParametersGroup.InteractiveParameters.capacities.elements[capacityIndex].applyToSelfAndRelated('getUnclicked');
                    } else {
                        if (!this.InteractiveParameter.InteractiveParametersGroup.InteractiveParameters.capacities.elements[capacityIndex].hidden) {
                            this.InteractiveParameter.InteractiveParametersGroup.InteractiveParameters.capacities.elements[capacityIndex].applyToSelfAndRelated('getHidden');
                        }
                    }
                }
                // Нажимаю на первую емкость, разрешая нажатие на недоступный элемент, так как емкость может быть ранее выбранной и недоступной
                this.InteractiveParameter.InteractiveParametersGroup.InteractiveParameters.capacities.clickFirst(true);
            } else {
                // Если нет емкостей, рассматриваю цвет
                $.each(this.data['capacity_to_price'], function (capacity, price) {
                    // Рассматриваю первое значение "data-capacity_to_price"
                    ProductPageInteractiveParametersManager.updatePrice(price);
                    return false;
                });
                ProductPageInteractiveParametersManager.updateProductId(this.data['product_id']);
            }
            if (!ProductPageInteractiveParametersManager.pageWithDrawinglogoHash && document.location.hash == '') {
                document.location.hash = this.index;
            }
        }
    },
    // Емкость
    capacities: {
        selector: '.capacity-container__capacity-value',
        indexBy: 'text()',
        classActive: 'active',
        classHidden: 'hidden',
        disabledCursor: 'default',
        /**
         * @this InteractiveParameterElement
         */
        onClick: function () {
            if (this.InteractiveParameter.InteractiveParametersGroup.isParameterDefinedAndHasElements('colors')) {
                // Работаю с активным элементом, если не скрытых элементов больше одного
                if (this.InteractiveParameter.getNotHiddenElementsCount() > 1) {
                    if (this.InteractiveParameter.active) {
                        this.InteractiveParameter.active.applyToSelfAndRelated('getEnabled');
                        this.InteractiveParameter.active.applyToSelfAndRelated('getUnclicked');
                    }
                }
                this.applyToSelfAndRelated('getDisabled');
                this.applyToRelated('getClicked', [true]);
                var activeColor = this.InteractiveParameter.InteractiveParametersGroup.InteractiveParameters.colors.active;
                if (activeColor) {
                    if (!this.InteractiveParameter.isActive(this.index)) {
                        this.InteractiveParameter.applyToSelfAndRelated('makeOnlyActive', [this.index]);
                    }
                    if (activeColor.data['capacity_to_price']) {
                        ProductPageInteractiveParametersManager.updatePrice(activeColor.data['capacity_to_price'][this.index]);
                    }
                    if (activeColor.data['capacity_to_product_id']) {
                        ProductPageInteractiveParametersManager.updateProductId(activeColor.data['capacity_to_product_id'][this.index]);
                    }

                    if (activeColor.data['capacity_to_interface_to_price'][this.index] && this.InteractiveParameter.InteractiveParametersGroup.isParameterDefinedAndHasElements('interfaces')) {
                        for (var interfaceIndex in this.InteractiveParameter.InteractiveParametersGroup.InteractiveParameters.interfaces.elements) {
                            if (activeColor.data['capacity_to_interface_to_price'][this.index][interfaceIndex] > 0) {
                                if (this.InteractiveParameter.InteractiveParametersGroup.InteractiveParameters.interfaces.elements[interfaceIndex].hidden) {
                                    this.InteractiveParameter.InteractiveParametersGroup.InteractiveParameters.interfaces.elements[interfaceIndex].applyToSelfAndRelated('getShown');
                                }
                                // Обнуляю нажатие на интерфейс, чтобы отрабатывало нажатие на интерфейс
                                this.InteractiveParameter.InteractiveParametersGroup.InteractiveParameters.interfaces.elements[interfaceIndex].applyToSelfAndRelated('getUnclicked');
                            } else {
                                if (!this.InteractiveParameter.InteractiveParametersGroup.InteractiveParameters.interfaces.elements[interfaceIndex].hidden) {
                                    this.InteractiveParameter.InteractiveParametersGroup.InteractiveParameters.interfaces.elements[interfaceIndex].applyToSelfAndRelated('getHidden');
                                }
                            }
                        }
                        // Нажимаю на первый интерфейс
                        this.InteractiveParameter.InteractiveParametersGroup.InteractiveParameters.interfaces.clickFirst(true);
                    }
                }
            }
        }
    },
    // Интерфейс
    interfaces: {
        selector: '.interface-container__interface-value',
        indexBy: 'text()',
        classActive: 'active',
        classHidden: 'hidden',
        disabledCursor: 'default',
        /**
         * @this InteractiveParameterElement
         */
        onClick: function () {
            if (this.InteractiveParameter.InteractiveParametersGroup.isParameterDefinedAndHasElements('colors')) {
                // Работаю с активным элементом, если не скрытых элементов больше одного
                if (this.InteractiveParameter.getNotHiddenElementsCount() > 1) {
                    if (this.InteractiveParameter.active) {
                        this.InteractiveParameter.active.applyToSelfAndRelated('getEnabled');
                        this.InteractiveParameter.active.applyToSelfAndRelated('getUnclicked');
                    }
                }
                //this.applyToSelfAndRelated('getDisabled');
                this.applyToRelated('getClicked', [true]);

                var activeColor = this.InteractiveParameter.InteractiveParametersGroup.InteractiveParameters.colors.active;
                var activeCapacity = this.InteractiveParameter.InteractiveParametersGroup.InteractiveParameters.capacities.active;
                if (activeColor && activeCapacity) {
                    if (!this.InteractiveParameter.isActive(this.index)) {
                        this.InteractiveParameter.applyToSelfAndRelated('makeOnlyActive', [this.index]);
                    }
                    if (activeColor.data['capacity_to_interface_to_price']) {
                        console.log(this.index);
                        ProductPageInteractiveParametersManager.updatePrice(activeColor.data['capacity_to_interface_to_price'][activeCapacity.index][this.index]);
                    }
                    if (activeColor.data['capacity_to_interface_to_product_id']) {
                        ProductPageInteractiveParametersManager.updateProductId(activeColor.data['capacity_to_interface_to_price'][activeCapacity.index][this.index]);
                    }
                }
            }
        }
    }
};
/**
 * Группа параметров при немобильном отображении
 * @type {InteractiveParametersGroup}
 */
var desktopInteractiveParametersGroup = new InteractiveParametersGroup({
    InteractiveParametersConstructorParams: {
        // Цвет
        colors: InteractiveParametersParams.colors,
        // Емкость
        capacities: InteractiveParametersParams.capacities,
        // Интерфейсы
        interfaces: InteractiveParametersParams.interfaces
    },
    selector: '.product-card-container.product'
});
/**
 * Группа параметров при мобильном отображении
 * @type {InteractiveParametersGroup}
 */
var mobileInteractiveParametersGroup = new InteractiveParametersGroup({
    InteractiveParametersConstructorParams: {
        // Цвет
        colors: InteractiveParametersParams.colors,
        // Емкость
        capacities: InteractiveParametersParams.capacities,
        // Емкость
        interfaces: InteractiveParametersParams.interfaces
    },
    selector: '.product-card-container.product-card-container__common'
});
// Связывание групп
desktopInteractiveParametersGroup.relateWith(mobileInteractiveParametersGroup);
// Инициализация параметров в группах
desktopInteractiveParametersGroup.initInteractiveParameters(['colors']);



// WEBPACK FOOTER //
// ./assets/javascript/interactive_parameters/product_page_interactive_parameters.js